/* @preserve
    _____ __ _     __                _
   / ___// /(_)___/ /___  ____      (_)___
  / (_ // // // _  // -_)/ __/_    / /(_-<
  \___//_//_/ \_,_/ \__//_/  (_)__/ //___/
                              |___/

  Version: 1.7.4
  Author: Nick Piscitelli (pickykneee)
  Website: https://nickpiscitelli.com
  Documentation: http://nickpiscitelli.github.io/Glider.js
  License: MIT License
  Release Date: October 25th, 2018

*/
!function(e){"function"==typeof define&&define.amd?define(e):"object"==typeof exports?module.exports=e():e()}(function(){var a="undefined"!=typeof window?window:this,e=a.Glider=function(e,t){var i=this;if(e._glider)return e._glider;if(i.ele=e,i.ele.classList.add("glider"),(i.ele._glider=i).opt=Object.assign({},{slidesToScroll:1,slidesToShow:1,resizeLock:!0,duration:.5,passiveListeners:!1,easing:function(e,t,i,o,s){return o*(t/=s)*t+i}},t),i.animate_id=i.page=i.slide=0,i.arrows={},i._opt=i.opt,i.opt.skipTrack)i.track=i.ele.children[0];else for(i.track=document.createElement("div"),i.ele.appendChild(i.track);1!==i.ele.children.length;)i.track.appendChild(i.ele.children[0]);i.track.classList.add("glider-track"),i.init(),i.resize=i.init.bind(i,!0),i.event(i.ele,"add",{scroll:i.updateControls.bind(i)},{passive:i.opt.passiveListeners}),i.event(a,"add",{resize:i.resize})},t=e.prototype;return t.init=function(e,t){var i,o=this,s=0,r=0,l=(o.slides=o.track.children,[].forEach.call(o.slides,function(e,t){e.classList.add("glider-slide"),e.setAttribute("data-gslide",t)}),o.containerWidth=o.ele.clientWidth,o.settingsBreakpoint());t=t||l,"auto"!==o.opt.slidesToShow&&void 0===o.opt._autoSlide||(i=o.containerWidth/o.opt.itemWidth,o.opt._autoSlide=o.opt.slidesToShow=o.opt.exactWidth?i:Math.max(1,Math.floor(i))),"auto"===o.opt.slidesToScroll&&(o.opt.slidesToScroll=Math.floor(o.opt.slidesToShow)),o.itemWidth=o.opt.exactWidth?o.opt.itemWidth:o.containerWidth/o.opt.slidesToShow,[].forEach.call(o.slides,function(e){e.style.height="auto",e.style.width=o.itemWidth+"px",s+=o.itemWidth,r=Math.max(e.offsetHeight,r)}),o.track.style.width=s+"px",o.trackWidth=s,o.isDrag=!1,o.preventClick=!1,o.move=!1,o.opt.resizeLock&&o.scrollTo(o.slide*o.itemWidth,0),(l||t)&&(o.bindArrows(),o.buildDots(),o.bindDrag()),o.updateControls(),o.emit(e?"refresh":"loaded")},t.bindDrag=function(){function e(){t.mouseDown=void 0,t.ele.classList.remove("drag"),t.isDrag&&(t.preventClick=!0),t.isDrag=!1}var t=this;t.mouse=t.mouse||t.handleMouse.bind(t);function i(){t.move=!0}var o={mouseup:e,mouseleave:e,mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.mouseDown=e.clientX,t.ele.classList.add("drag"),t.move=!1,setTimeout(i,300)},touchstart:function(e){t.ele.classList.add("drag"),t.move=!1,setTimeout(i,300)},mousemove:t.mouse,click:function(e){t.preventClick&&t.move&&(e.preventDefault(),e.stopPropagation()),t.preventClick=!1,t.move=!1}};t.ele.classList.toggle("draggable",!0===t.opt.draggable),t.event(t.ele,"remove",o),t.opt.draggable&&t.event(t.ele,"add",o,{passive:t.opt.passiveListeners})},t.buildDots=function(){var e=this;if(e.opt.dots){if("string"==typeof e.opt.dots?e.dots=document.querySelector(e.opt.dots):e.dots=e.opt.dots,e.dots){e.dots.innerHTML="",e.dots.setAttribute("role","tablist"),e.dots.classList.add("glider-dots");for(var t=0;t<Math.ceil(e.slides.length/e.opt.slidesToShow);++t){var i=document.createElement("button");i.dataset.index=t,i.setAttribute("aria-label","Page "+(t+1)),i.setAttribute("role","tab"),i.className="glider-dot "+(t?"":"active"),e.event(i,"add",{click:e.scrollItem.bind(e,t,!0)}),e.dots.appendChild(i)}}}else e.dots&&(e.dots.innerHTML="")},t.bindArrows=function(){var i=this;i.opt.arrows?["prev","next"].forEach(function(e){var t=i.opt.arrows[e];(t=t&&("string"==typeof t?document.querySelector(t):t))&&(t._func=t._func||i.scrollItem.bind(i,e),i.event(t,"remove",{click:t._func}),i.event(t,"add",{click:t._func}),i.arrows[e]=t)}):Object.keys(i.arrows).forEach(function(e){e=i.arrows[e];i.event(e,"remove",{click:e._func})})},t.updateControls=function(e){var n=this,t=(e&&!n.opt.scrollPropagate&&e.stopPropagation(),n.containerWidth>=n.trackWidth),a=(n.opt.rewind||(n.arrows.prev&&(n.arrows.prev.classList.toggle("disabled",n.ele.scrollLeft<=0||t),n.arrows.prev.setAttribute("aria-disabled",n.arrows.prev.classList.contains("disabled"))),n.arrows.next&&(n.arrows.next.classList.toggle("disabled",Math.ceil(n.ele.scrollLeft+n.containerWidth)>=Math.floor(n.trackWidth)||t),n.arrows.next.setAttribute("aria-disabled",n.arrows.next.classList.contains("disabled")))),n.slide=Math.round(n.ele.scrollLeft/n.itemWidth),n.page=Math.round(n.ele.scrollLeft/n.containerWidth),n.slide+Math.floor(Math.floor(n.opt.slidesToShow)/2)),d=Math.floor(n.opt.slidesToShow)%2?0:a+1;1===Math.floor(n.opt.slidesToShow)&&(d=0),n.ele.scrollLeft+n.containerWidth>=Math.floor(n.trackWidth)&&(n.page=n.dots?n.dots.children.length-1:0),[].forEach.call(n.slides,function(e,t){var i=e.classList,e=i.contains("visible"),o=n.ele.scrollLeft,s=n.ele.scrollLeft+n.containerWidth,r=n.itemWidth*t,l=r+n.itemWidth,r=([].forEach.call(i,function(e){/^left|right/.test(e)&&i.remove(e)}),i.toggle("active",n.slide===t),a===t||d&&d===t?i.add("center"):(i.remove("center"),i.add([t<a?"left":"right",Math.abs(t-(!(t<a)&&d||a))].join("-"))),Math.ceil(r)>=Math.floor(o)&&Math.floor(l)<=Math.ceil(s));i.toggle("visible",r),r!==e&&n.emit("slide-"+(r?"visible":"hidden"),{slide:t})}),n.dots&&[].forEach.call(n.dots.children,function(e,t){e.classList.toggle("active",n.page===t)}),e&&n.opt.scrollLock&&(clearTimeout(n.scrollLock),n.scrollLock=setTimeout(function(){clearTimeout(n.scrollLock),.02<Math.abs(n.ele.scrollLeft/n.itemWidth-n.slide)&&(n.mouseDown||n.trackWidth>n.containerWidth+n.ele.scrollLeft&&n.scrollItem(n.getCurrentSlide()))},n.opt.scrollLockDelay||250))},t.getCurrentSlide=function(){return this.round(this.ele.scrollLeft/this.itemWidth)},t.scrollItem=function(e,t,i){i&&i.preventDefault();var o,s=this,r=e,i=(++s.animate_id,s.slide),l=!0===t?(e=Math.round(e*s.containerWidth/s.itemWidth))*s.itemWidth:("string"==typeof e&&(l="prev"===e,e=s.opt.slidesToScroll%1||s.opt.slidesToShow%1?s.getCurrentSlide():s.slide,l?e-=s.opt.slidesToScroll:e+=s.opt.slidesToScroll,s.opt.rewind&&(o=s.ele.scrollLeft,e=l&&!o?s.slides.length:!l&&o+s.containerWidth>=Math.floor(s.trackWidth)?0:e)),e=Math.max(Math.min(e,s.slides.length),0),s.slide=e,s.itemWidth*e);return s.emit("scroll-item",{prevSlide:i,slide:e}),s.scrollTo(l,s.opt.duration*Math.abs(s.ele.scrollLeft-l),function(){s.updateControls(),s.emit("animated",{value:r,type:"string"==typeof r?"arrow":t?"dot":"slide"})}),!1},t.settingsBreakpoint=function(){var e=this,t=e._opt.responsive;if(t){t.sort(function(e,t){return t.breakpoint-e.breakpoint});for(var i=0;i<t.length;++i){var o=t[i];if(a.innerWidth>=o.breakpoint)return e.breakpoint!==o.breakpoint&&(e.opt=Object.assign({},e._opt,o.settings),e.breakpoint=o.breakpoint,!0)}}var s=0!==e.breakpoint;return e.opt=Object.assign({},e._opt),e.breakpoint=0,s},t.scrollTo=function(t,i,o){var s=this,r=(new Date).getTime(),l=s.animate_id,n=function(){var e=(new Date).getTime()-r;s.ele.scrollLeft=s.ele.scrollLeft+(t-s.ele.scrollLeft)*s.opt.easing(0,e,0,1,i),e<i&&l===s.animate_id?a.requestAnimationFrame(n):(s.ele.scrollLeft=t,o&&o.call(s))};a.requestAnimationFrame(n)},t.removeItem=function(e){var t=this;t.slides.length&&(t.track.removeChild(t.slides[e]),t.refresh(!0),t.emit("remove"))},t.addItem=function(e){this.track.appendChild(e),this.refresh(!0),this.emit("add")},t.handleMouse=function(e){var t=this;t.mouseDown&&(t.isDrag=!0,t.ele.scrollLeft+=(t.mouseDown-e.clientX)*(t.opt.dragVelocity||3.3),t.mouseDown=e.clientX)},t.round=function(e){var t=1/(this.opt.slidesToScroll%1||1);return Math.round(e*t)/t},t.refresh=function(e){this.init(!0,e)},t.setOption=function(t,e){var i=this;i.breakpoint&&!e?i._opt.responsive.forEach(function(e){e.breakpoint===i.breakpoint&&(e.settings=Object.assign({},e.settings,t))}):i._opt=Object.assign({},i._opt,t),i.breakpoint=0,i.settingsBreakpoint()},t.destroy=function(){function e(t){t.removeAttribute("style"),[].forEach.call(t.classList,function(e){/^glider/.test(e)&&t.classList.remove(e)})}var t=this,i=t.ele.cloneNode(!0);t.opt.skipTrack||(i.children[0].outerHTML=i.children[0].innerHTML),e(i),[].forEach.call(i.getElementsByTagName("*"),e),t.ele.parentNode.replaceChild(i,t.ele),t.event(a,"remove",{resize:t.resize}),t.emit("destroy")},t.emit=function(e,t){e=new a.CustomEvent("glider-"+e,{bubbles:!this.opt.eventPropagate,detail:t});this.ele.dispatchEvent(e)},t.event=function(e,t,i){var o=e[t+"EventListener"].bind(e);Object.keys(i).forEach(function(e){o(e,i[e])})},e});

  // Derivative Slider Setup
  const derivativeSlider = document.querySelector('#derivative-slider');
  if (derivativeSlider) {
    const derivativeSliderGlider = new Glider(derivativeSlider, {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '#glider-prev',
        next: '#glider-next'
      }
    });

      const sliderEl = document.querySelector('#derivative-slider');
      if (sliderEl && sliderEl._glider) {
        const g = sliderEl._glider;

        sliderEl.addEventListener('touchstart', (e) => {
          g.mouseDown = e.touches[0].clientX;
        }, { passive: true });

        sliderEl.addEventListener('touchmove', (e) => {
          if (g.mouseDown == null) return;
          g.handleMouse({ clientX: e.touches[0].clientX });
          e.preventDefault(); // stop the page stealing the gesture
        }, { passive: false });

        sliderEl.addEventListener('touchend', () => {
          g.mouseDown = undefined;
        }, { passive: true });
      }

    //   derivativeSliderGlider.ele.addEventListener('glider-slide-visible', function(event) {
    //   const { slide, slides } = event.detail;

    //   // Load current slide
    //   loadLazy(slide);

    //   // Preload next slide
    //   if (slides[slide + 1]) {
    //     loadLazy(slides[slide + 1]);
    //   }
    // });

    function loadLazy(slide) {
      const img = slide.querySelector('img.glider-lazy');
      if (img && img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
    }

    // setupAutoSlide(glider, derivativeSlider, 5000);

    // document.querySelectorAll('.side-img').forEach((img) => {
    //   img.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     const targetId = img.getAttribute('data-imageid');
    //     const slides = derivativeSlider.querySelectorAll('li');

    //     slides.forEach((slide, index) => {
    //       if (slide.getAttribute('data-sliderimageid') === targetId) {
    //         glider.scrollItem(index);
    //       }
    //     });
    //   });
    // });

    document.querySelector('#glider-prev')?.addEventListener('click', () => console.log('prev clicked'));
    document.querySelector('#glider-next')?.addEventListener('click', () => console.log('next clicked'));
  }

  // Used EV image gallery
  document.querySelectorAll('.deal-gallery').forEach((gallery) => {
    const galleryTrack = gallery.querySelector('.deal-gallery-track');
    const mainImage = gallery.querySelector('.deal-gallery-main #main-img');
    const thumbnails = galleryTrack
      ? Array.from(galleryTrack.querySelectorAll('.gallery-thumb'))
      : [];

    if (!galleryTrack || !mainImage || !thumbnails.length) {
      return;
    }

    const controls = gallery.querySelector('.deal-gallery-controls');
    const previousButton = controls?.querySelector('.glider-prev');
    const nextButton = controls?.querySelector('.glider-next');

    new Glider(galleryTrack, {
      slidesToScroll: 1,
      slidesToShow: 2,
      draggable: true,
      scrollLock: true,
      arrows: previousButton && nextButton ? {
        prev: previousButton,
        next: nextButton
      } : undefined,
      responsive: [
        {
          breakpoint: 510,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 1024,
          settings: { slidesToShow: 4 }
        },
        {
          breakpoint: 1900,
          settings: { slidesToShow: 5 }
        }
      ]
    });

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();

        thumbnails.forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');

        if (thumbnail.dataset.img) {
          mainImage.src = thumbnail.dataset.img;
        }

        const videoMain = gallery.matches('.has-video')
          ? gallery.querySelector('.deal-gallery-main')
          : null;

        videoMain?.classList.toggle('video-trigger', index === 0);
      });
    });
  });

  // For Drivers testimonial slider
  const isForDriversPage = window.location.pathname.replace(/^\/+|\/+$/g, '') === 'for-drivers';
  const testimonialContent = isForDriversPage
    ? document.querySelector('#content-section-6 .article-wysiwyg-content')
    : null;
  const testimonials = testimonialContent
    ? Array.from(testimonialContent.querySelectorAll(':scope > blockquote'))
    : [];

  if (testimonials.length > 1) {
    const firstTestimonial = testimonials[0];
    const testimonialStrip = document.createElement('div');
    const testimonialListWrapper = document.createElement('div');
    const testimonialList = document.createElement('div');
    const testimonialArrows = document.createElement('div');
    const testimonialPrev = document.createElement('button');
    const testimonialNext = document.createElement('button');
    const testimonialDots = document.createElement('div');

    testimonialStrip.className = 'testimonial-strip';
    testimonialStrip.setAttribute('aria-label', 'Driver testimonials');
    testimonialStrip.setAttribute('aria-roledescription', 'carousel');

    testimonialListWrapper.className = 'testimonial-list-wrapper';
    testimonialList.className = 'testimonial-list';
    testimonialArrows.className = 'glider-arrows';

    testimonialPrev.type = 'button';
    testimonialPrev.className = 'glider-arrow glider-prev';
    testimonialPrev.setAttribute('aria-label', 'Previous testimonial');

    testimonialNext.type = 'button';
    testimonialNext.className = 'glider-arrow glider-next';
    testimonialNext.setAttribute('aria-label', 'Next testimonial');

    testimonialDots.className = 'testimonial-dots';

    firstTestimonial.parentNode.insertBefore(testimonialStrip, firstTestimonial);
    testimonialStrip.appendChild(testimonialListWrapper);
    testimonialListWrapper.appendChild(testimonialList);
    testimonialArrows.appendChild(testimonialPrev);
    testimonialArrows.appendChild(testimonialNext);
    testimonialListWrapper.appendChild(testimonialArrows);
    testimonialStrip.appendChild(testimonialDots);

    testimonials.forEach((testimonial, index) => {
      testimonial.classList.add('testimonial');
      testimonial.setAttribute('role', 'group');
      testimonial.setAttribute('aria-roledescription', 'slide');
      testimonial.setAttribute('aria-label', `${index + 1} of ${testimonials.length}`);
      testimonialList.appendChild(testimonial);
    });

    new Glider(testimonialList, {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      scrollLock: true,
      rewind: true,
      dots: testimonialDots,
      arrows: {
        prev: testimonialPrev,
        next: testimonialNext
      }
    });
  }
